<template>
  <fiche-header :ressource="ressource"
                @back="back"
                @openAll="openAll"
                @closeAll="closeAll">
  </fiche-header>
  <div class="fiche">
    <v-col class="col-7">
      <section-cart-item-list :extended="isExtended('CART_ITEM_LIST')"
                              :showButton="true"
                              :readOnly="readOnly"
                              :moduleId="moduleId"
                              :ressourceHeader="ressource"
                              :fiche="fiche"
                              :cart="selectedCart"
                              :route="route"
                              :attribut="attribut"
                              @extended="setExtended"
                              @status="updateStatus"
                              @updated="cartUpdated"
                              @selectItem="selectItem">
      </section-cart-item-list>
    </v-col>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import FicheCartItemList from '@/generated/fiches/FicheCartItemList.vue';
import SectionCartItemList from '@/custom/sections/SectionCartItemList.vue';
import FicheHeader from '@/framework/base/components/FicheHeader.vue';

export default defineComponent({
  extends: FicheCartItemList,
  components: { SectionCartItemList, FicheHeader },
});
</script>
